<template>
<div>
    <div class="form_box">
        <el-form :inline="true" :model="formInline">
            <el-row>
                <el-form-item label="搜索" prop="keywords" >
                    <el-input v-model="formInline.keywords" placeholder="请输入关键字" @keyup.enter.native="search"></el-input>
                </el-form-item>
                <el-form-item>
                <el-button type="primary"  class="btn btn1" @click="search">搜索</el-button>
                </el-form-item>
            </el-row>
        </el-form>
    </div>
         <!-- 查询结果列表 -->
          <Table
            ref="hostsTable"
            :fieldData="fieldData"
            :tableData="tableData"
            :page="true"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            :total="total"
            type="index"
            :tableSort="tableSort"
            :cellStyles="cellStyles"
            :headerStyles="headerStyles"
            style="width: 100%; margin-top: 20px;"
            >
            <el-table-column
              prop:id
              slot="opts"
              label="操作"
              min-width="150px"
              >
              <template slot-scope="scope" >
                <el-button type="text" size="small" @click="getNotice(scope.row)">意见通知书</el-button>
                <el-button  type="text" size="small"  @click="toEdit(scope.row.id)">材料补正</el-button>
              </template>
            </el-table-column>
          </Table>
</div>




</template>

<script>
import {getTodolists,getNotice,showFile } from "../../api/home"
import Table from "../../../comm/components/Table/index.vue"
import { downloadFiles } from "../../../comm/utils/download"

export default {
    components:{Table},

    data(){
        return{
            formInline:{
               keywords:''
            },
            //表格样式
            headerStyles:
            {
            color:'rgb(255, 255, 255)',
            padding: '0.375rem',
            'border-right': '2px solid #ffffff',
            'text-align': 'center',
            background: 'rgb(27, 61, 109)'
            },
            cellStyles: {'text-align': 'center'},
            tableSort: { prop: "id", order: "descending" }, // 默认排序规则

            keywords:'',
            total:0,
            pageSize:10,
            currentPage:1,
            tableData:[],
            //申请编号，产品名称，申请机构，申请机构电话，申请时间，通知下发时间
            fieldData:[
                {
                    field:"applicationNumber",
                    label:"申请编号",
                    width:"120px",
                    sortable:false
                },
                {
                    field:"name",
                    label:"产品名称",
                    width:"130px",
                    sortable:false
                },
                {
                    field:"applyName",
                    label:"申请机构",
                    width:"130px",
                    sortable:false
                },
                {
                    field:"applyPhone",
                    label:"申请机构电话",
                    width:"150px",
                    sortable:false
                },
                {
                    field:"applyTime",
                    label:"申请时间",
                    width:"120px",
                    sortable:false
                },
                {
                    field:"entryTime",
                    label:"技术审查通知下发时间",
                    width:"180px",
                    sortable:false
                }

            ],

        }
    },
    mounted(){
        this.submitForm()
    },
    methods:{
        search(){
            this.currentPage =1
            this.submitForm()
        },
        submitForm(){
            let params ={
                type :'Evaluation_BZ',//技术审查材料补正
                keyWord:this.formInline.keywords,
                page:this.currentPage,
                limit:this.pageSize
            }
            console.log(params)
            getTodolists(params).then(res=>{
                if(res.success){
                    this.tableData = res.data.data
                    this.total = res.data.count
                }

                }

        )},

        //获取补正通知
        getNotice(val){
            let params ={
                applyId:val.id,
                version:val.version,
                state:val.state,  //所处状态Trial_BZ， FormalExamination_BZ， Evaluation_BZ
            }
            getNotice(params).then(res=>{
                if(res.errorCode == 200){
                    let filePath = res.data.fileurl
                   // let filePath = 'dbsbhz/File/application/2024140016/0/操作说明.pdf'
                    let fileName = res.data.filename
                    console.log("文件路径是",filePath)
                    showFile(filePath).then(res=>{
                            downloadFiles(res, fileName)
                    })
                }else {
                    this.$message.error(res.errorMsg)
                }
                }
            )
        },

      //编辑
      toEdit(id){

        this.$router.push({path:'/drafsEdit',query:{applyId:id}})

      },

      // 分页
    pageChange(pageIndex) {
      //console.log("触发分页事件");
      this.currentPage = pageIndex;
      this.submitForm();
    },
    sizeChange(size) {
      //console.log("触发改变每页条数的事件");
      //console.log(size);
      this.pageSize = size;
      this.submitForm();
    },
    }

}
</script>

<style lang="less" scoped>
.btn{
  font-size: 1rem;
  width: 7.375rem;
  border-radius: 4px;
  overflow: hidden;
}
.btn1{
  background: rgb(1, 137, 220);
  color: rgb(255, 253, 253);
}
.btn2{
  color: rgb(1, 137, 220);
  border: 1px solid rgb(1, 137, 220);
  background:rgb(255, 255, 255)
}

</style>



// WEBPACK FOOTER //
// src/landmark-user/views/techEvaluationBZ/index.vue